import Wallop from 'wallop';

class Pagination {
  constructor(el, opts) {
    this.el = el;
    this.options = opts;
    this.init();
  }

  // Initialise
  init() {
    this.carousel = new Wallop(this.el, this.options);

    this.carousel.on('change', e => this.change(e));

    if ( this.options.dots ) {
      this.initDots();
    }

    if ( this.options.dynamicHeight ) {
      this.wrapper = this.getEl(this.options.wrapperClass)[0];
    }
  }

  change(e) {
    if ( this.options.dots && this.dots.length ) {
      this.getEl(this.options.dotClass + '.is-active')[0].classList.remove('is-active');
      this.dots[event.detail.currentItemIndex].classList.add('is-active');
    }
    if ( this.options.dynamicHeight && this.wrapper ) {
      let newHeight = this.carousel.allItemsArray[this.carousel.currentItemIndex].offsetHeight;
      this.wrapper.style.height = newHeight + 'px';
    }
  }

  initDots() {
    this.dots = this.getEl(this.options.dotClass);
    for ( let i = 0; i < this.dots.length; i++ ) {
      this.dots[i].addEventListener('click', e => this.jump(e));
    }
  }

  jump(e) {
    this.carousel.goTo(parseInt(e.target.text) - 1);
  }

  // Helpers
  getEl(selector) {
    return this.el.querySelectorAll('.' + selector);
  }

}

export default Pagination;



// WEBPACK FOOTER //
// ./scripts/components/pagination.js